import { i18n } from '@lingui/core';
import React from 'react';
import { IconButton, ListMusicNoteOutlined } from '@landr/maestro';
import { getWebAppLink, openWebAppLink } from '@landr/core';
import { useLinkClickHandler } from '../../../../../hooks/useLinkClickHandler.es.js';
import { useNavBarContext } from '../../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { Links } from '../../../../../../../enums/Links.es.js';

var LibraryIcon = function LibraryIcon() {
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env;
  var linkClickHandler = useLinkClickHandler();
  return /*#__PURE__*/React.createElement(IconButton, {
    sx: {
      color: 'neutral.400'
    },
    as: "a",
    href: getWebAppLink(env, Links.Library),
    size: "sm",
    label: i18n._(
    /*i18n*/
    {
      id: "exYcTF"
    }),
    icon: ListMusicNoteOutlined,
    variant: "ghost",
    kind: "minimal",
    isRounded: true,
    onClick: linkClickHandler(openWebAppLink, env, Links.Library)
  });
};

export { LibraryIcon };
